import React, { useState, useEffect, useMemo } from "react";
import Visa from "@/public/cards/visa-card.svg";
import Amex from "@/public/cards/card-amex-v2.svg";
import Diners from "@/public/cards/diners-club-v2.svg";
import Discover from "@/public/cards/card-discover.svg";
import Elo from "@/public/cards/card-elo.svg";
import Jcb from "@/public/cards/card-jsb.svg";
import Maestro from "@/public/cards/card-maestro.svg";
import Union from "@/public/cards/card-union.svg";

const CreditCards = () => {
  const imagesArray = [Visa, Maestro, Amex, Diners, Discover, Elo, Jcb, Union];
  const [tooltipActive, setTooltipActive] = useState(false);
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowSize(window.innerWidth);
  };

  const visibleCards = useMemo(() => {
    if (windowSize >= 1071) {
      return { show: imagesArray.slice(0, 4), hide: imagesArray.slice(4) };
    }
    if (windowSize < 1071 && windowSize > 390) {
      return { show: imagesArray.slice(0, 4), hide: imagesArray.slice(4) };
    }
    if (windowSize <= 390) {
      return { show: imagesArray.slice(0, 2), hide: imagesArray.slice(2) };
    }
  }, [windowSize]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="cardsContainer">
      {visibleCards.show &&
        visibleCards.show.map((image, index) => {
          return (
            <img key={index} width="35" height="22" className="cardsContainer__cardImage" src={image} alt={image} />
          );
        })}
      <div
        className="cardsContainer__cardImage cardsContainer__cardImage--placeholder"
        onClick={() => {
          if (window.isMobile) {
            setTooltipActive(!tooltipActive);
          }
        }}
      >
        +{visibleCards.hide.length}
        <div className={`${tooltipActive ? "tooltip tooltip--active" : "tooltip"}`} visible={tooltipActive.toString()}>
          <div className="tooltip__wrapper">
            {visibleCards.hide &&
              visibleCards.hide.map((image, index) => {
                return (
                  <img
                    key={index}
                    className="cardsContainer__cardImage"
                    width="35"
                    height="22"
                    src={image}
                    alt={image}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditCards;
